import React from "react";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { reorderFields, getFieldLabel as defaultGetFieldLabel } from "../../utils/fieldOrder";

export default function FieldReorderList({
  orderedFields,
  onOrderChange,
  sections,
  getFieldLabel = defaultGetFieldLabel,
  highlightedFieldId,
  onMoveToTop,
}) {
  const onDragEnd = (result) => {
    const newOrderedFields = reorderFields(orderedFields, result);

    // Only trigger update if the object reference changed (which reorderFields ensures if changes happened)
    if (newOrderedFields !== orderedFields) {
      onOrderChange(newOrderedFields);
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {sections.map((section) => (
        <Paper key={section.id} data-section-id={section.id} sx={{ mb: 2 }}>
          <Typography fontWeight={500} fontSize={18} pt={2} pb={1} mx={2}>
            {section.title}
          </Typography>
          <Droppable droppableId={section.id}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{
                  backgroundColor: snapshot.isDraggingOver ? "#e3f2fd" : "transparent",
                  transition: "background-color 0.2s ease",
                  padding: "12px 16px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                  paddingBottom: 16,
                  minHeight: 48,
                }}
              >
                {(orderedFields[section.id] || []).map((field, index) => (
                  <Draggable key={field.id} draggableId={field.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        data-field-id={field.id}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{
                          ...provided.draggableProps.style,
                        }}
                      >
                        <Box
                          display="flex"
                          alignItems="center"
                          p={1}
                          px={2}
                          border={field.id === highlightedFieldId ? "3px solid" : "1px solid"}
                          borderColor={
                            snapshot.isDragging || field.id === highlightedFieldId
                              ? "primary.main"
                              : "divider"
                          }
                          borderRadius={1}
                          sx={{ cursor: "grab" }}
                        >
                          <Typography color="text.primary">{getFieldLabel(field)}</Typography>
                          {onMoveToTop && (
                            <IconButton
                              size="small"
                              onClick={event => {
                                event.stopPropagation();
                                onMoveToTop(field, section.id);
                              }}
                              sx={{ ml: "auto", opacity: 0, ".MuiBox-root:hover &": { opacity: 1 } }}
                            >
                              <ArrowUpwardIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </Paper>
      ))}
    </DragDropContext>
  );
}
